import { EventDispatcher, Vector2 } from 'three';

import { debounce } from '../utils';

// controls the banking and parallax effect when the mouse moves
export default class Parallax extends EventDispatcher {
  constructor(camera, beacons, tab, container) {
    super();
    this.camera = camera;
    this.beacons = Object.keys(beacons);

    // todo: set on window resize
    this.container = container;
    this.containerHalfWidth = container.clientWidth / 2;
    this.containerHalfHeight = container.clientHeight / 2;

    this.onResize = this.onResize.bind(this);
    window.addEventListener('DOMContentLoaded', this.onResize);
    const debouncedResize = debounce(this.onResize, 500);
    window.addEventListener('resize', debouncedResize);

    this.mouse = new Vector2();
    this.rotateSpeed = 0.00035;
    this.maxRotate = 0.05;
    this.direction = 'idle';

    this.onMouseMove = this.onMouseMove.bind(this);
    this.onBeaconTabbed = this.onBeaconTabbed.bind(this);
    tab.addEventListener('onBeaconTabbed', this.onBeaconTabbed);

    this.update = this.update.bind(this);
    // Only tilt for mouse input, not touch
    if (!('ontouchstart' in document.documentElement)) this.update();
  }

  onResize() {
    this.containerHalfWidth = this.container.clientWidth / 2;
    this.containerHalfHeight = this.container.clientHeight / 2;
  }

  onBeaconTabbed(args) {
    const index = this.beacons.indexOf(args.beacon);
    const position = index - (this.beacons.length - 1) / 2;
    this.mouse.x = position * 0.5;
  }

  onMouseMove(event) {
    this.mouse.x = (event.clientX - this.containerHalfWidth) * 0.001;
    this.mouse.y = (event.clientY - this.containerHalfHeight) * 0.001;
  }

  update() {
    const velocity = (this.mouse.x - this.camera.position.x + 0.75) * 0.005;
    this.camera.position.x += velocity;

    const speed = Math.abs(velocity);
    const IDLE_BREAKPOINT = 0.001;

    if (speed < IDLE_BREAKPOINT) this.setDirection('idle');
    else if (this.mouse.x > 0) this.setDirection('right');
    else if (this.mouse.x < 0) this.setDirection('left');


    if (this.direction === 'right' && this.camera.rotation.z < this.maxRotate) this.camera.rotation.z -= this.rotateSpeed;
    if (this.direction === 'left' && this.camera.rotation.z > -this.maxRotate) this.camera.rotation.z += this.rotateSpeed;
    if (this.direction === 'idle' && this.camera.rotation.z < 0) this.camera.rotation.z += this.rotateSpeed;
    if (this.direction === 'idle' && this.camera.rotation.z > 0) this.camera.rotation.z -= this.rotateSpeed;
    requestAnimationFrame(this.update);
  }

  setDirection(direction) {
    if (this.direction !== direction) this.dispatchEvent({ type: 'onDirectionChanged', direction });
    this.direction = direction;
  }

  setActive(value) {
    if (value) {
      document.addEventListener('mousemove', this.onMouseMove);
    } else {
      document.removeEventListener('mousemove', this.onMouseMove);
    }
  }
}
